import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Circle, Clock, Calendar, TrendingUp, BarChart3, Flame } from 'lucide-react';
interface Task {
  id: number;
  title: string;
  description: string;
  duration: string;
  completed: boolean;
  category: 'morning' | 'midday' | 'afternoon' | 'evening';
}
interface DailyStats {
  date: string;
  completed: number;
  total: number;
  completionRate: number;
}
export function LinkedInRoutine() {
  const [view, setView] = useState<'routine' | 'stats'>('routine');
  const [statsView, setStatsView] = useState<'week' | 'month' | 'year'>('week');
  const [currentStreak, setCurrentStreak] = useState(7);
  const [longestStreak, setLongestStreak] = useState(21);
  const [tasks, setTasks] = useState<Task[]>([{
    id: 1,
    title: 'Kommentare schreiben',
    description: '3-5 interessante Beiträge kommentieren (45min vor eigenem Post)',
    duration: '5-10min',
    completed: false,
    category: 'morning'
  }, {
    id: 2,
    title: 'Vernetzungsanfragen versenden',
    description: 'Max. 30 Anfragen an ideale Kunden',
    duration: '15min',
    completed: false,
    category: 'morning'
  }, {
    id: 3,
    title: 'Alte Anfragen zurückziehen',
    description: 'Anfragen älter als 1 Monat zurückziehen',
    duration: '3min',
    completed: false,
    category: 'morning'
  }, {
    id: 4,
    title: 'Erstnachrichten versenden',
    description: 'An alle neuen Kontakte',
    duration: '5min',
    completed: false,
    category: 'morning'
  }, {
    id: 5,
    title: 'Direktnachrichten beantworten',
    description: 'Offene Nachrichten zuerst',
    duration: '10min',
    completed: false,
    category: 'morning'
  }, {
    id: 6,
    title: 'Follow-up Terminvorschläge',
    description: 'Wer hat noch kein Feedback gegeben?',
    duration: '5min',
    completed: false,
    category: 'morning'
  }, {
    id: 7,
    title: 'Restliches Follow-up',
    description: 'Wiedervorlagen und ausstehende Rückmeldungen',
    duration: '10min',
    completed: false,
    category: 'morning'
  }, {
    id: 8,
    title: 'Kommentare schreiben',
    description: '3-5 interessante Beiträge kommentieren',
    duration: '5-10min',
    completed: false,
    category: 'midday'
  }, {
    id: 9,
    title: 'Beitrag veröffentlichen',
    description: '2-3 Beiträge pro Woche (5-7 für Maximum)',
    duration: 'variabel',
    completed: false,
    category: 'midday'
  }, {
    id: 10,
    title: 'Kommentare schreiben',
    description: '3-5 Beiträge kommentieren (bis 60min nach eigenem Post)',
    duration: '5-10min',
    completed: false,
    category: 'afternoon'
  }, {
    id: 11,
    title: 'Eigene Kommentare beantworten',
    description: 'Innerhalb der ersten Stunde nach Veröffentlichung',
    duration: '5min',
    completed: false,
    category: 'afternoon'
  }, {
    id: 12,
    title: 'Neue Direktnachrichten',
    description: 'Leadmagnet-Anforderungen, Vernetzungsanfragen, Content-Interaktionen',
    duration: '30min',
    completed: false,
    category: 'evening'
  }, {
    id: 13,
    title: 'Profilbesucher kontaktieren',
    description: 'Wer aus der Zielgruppe hat Profil besucht?',
    duration: '10min',
    completed: false,
    category: 'evening'
  }, {
    id: 14,
    title: 'Kalte Kontakte ansprechen',
    description: 'Personen ohne bisherige Interaktion',
    duration: '10min',
    completed: false,
    category: 'evening'
  }, {
    id: 15,
    title: 'Finale Kommentare beantworten',
    description: 'Alle offenen Kommentare checken',
    duration: '5min',
    completed: false,
    category: 'evening'
  }]);
  const [weeklyStats] = useState<DailyStats[]>([{
    date: '2025-01-20',
    completed: 15,
    total: 15,
    completionRate: 100
  }, {
    date: '2025-01-21',
    completed: 14,
    total: 15,
    completionRate: 93
  }, {
    date: '2025-01-22',
    completed: 15,
    total: 15,
    completionRate: 100
  }, {
    date: '2025-01-23',
    completed: 13,
    total: 15,
    completionRate: 87
  }, {
    date: '2025-01-24',
    completed: 15,
    total: 15,
    completionRate: 100
  }, {
    date: '2025-01-25',
    completed: 12,
    total: 15,
    completionRate: 80
  }, {
    date: '2025-01-26',
    completed: 14,
    total: 15,
    completionRate: 93
  }]);
  const [monthlyStats] = useState({
    averageCompletion: 92,
    totalTasks: 465,
    completedTasks: 428,
    bestDay: 'Montag',
    worstDay: 'Freitag'
  });
  const toggleTask = (id: number) => {
    setTasks(tasks.map(task => task.id === id ? {
      ...task,
      completed: !task.completed
    } : task));
  };
  const resetAll = () => {
    setTasks(tasks.map(task => ({
      ...task,
      completed: false
    })));
  };
  const saveDay = () => {
    const completedCount = tasks.filter(t => t.completed).length;
    console.log(`Saved: ${completedCount}/${tasks.length} tasks completed`);
    alert(`Tag gespeichert! ${completedCount}/${tasks.length} Aufgaben erledigt (${Math.round(completedCount / tasks.length * 100)}%)`);
  };
  const categories = [{
    key: 'morning',
    title: 'Morgen-Routine',
    description: 'Start in den Tag'
  }, {
    key: 'midday',
    title: 'Mittags-Routine',
    description: 'Content veröffentlichen'
  }, {
    key: 'afternoon',
    title: 'Nachmittags-Routine',
    description: 'Engagement steigern'
  }, {
    key: 'evening',
    title: 'Abend-Routine',
    description: 'Direktnachrichten & Follow-up'
  }];
  const getTasksByCategory = (category: string) => {
    return tasks.filter(t => t.category === category);
  };
  const getCompletedCount = (category: string) => {
    const categoryTasks = getTasksByCategory(category);
    return categoryTasks.filter(t => t.completed).length;
  };
  const getTotalDuration = (category: string) => {
    const categoryTasks = getTasksByCategory(category);
    return categoryTasks.reduce((acc, task) => {
      const match = task.duration.match(/(\d+)/);
      return acc + (match ? parseInt(match[1]) : 0);
    }, 0);
  };
  const getTotalCompleted = () => tasks.filter(t => t.completed).length;
  const getTotalCompletionRate = () => Math.round(getTotalCompleted() / tasks.length * 100);
  return <div className="p-6 space-y-6" data-id="element-254">
      <div className="flex items-center justify-between" data-id="element-255">
        <div data-id="element-256">
          <h1 className="text-3xl font-bold text-foreground" data-id="element-257">
            LinkedIn Routine
          </h1>
          <p className="text-muted-foreground mt-1" data-id="element-258">
            Die ultimative LinkedIn-Routine - Täglich tracken & auswerten
          </p>
        </div>
        <div className="flex gap-2" data-id="element-259">
          <Button variant={view === 'routine' ? 'default' : 'outline'} size="sm" onClick={() => setView('routine')} data-id="element-260">
            Routine
          </Button>
          <Button variant={view === 'stats' ? 'default' : 'outline'} size="sm" onClick={() => setView('stats')} data-id="element-261">
            Statistiken
          </Button>
        </div>
      </div>

      {view === 'stats' && <>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-262">
            <Card data-id="element-263">
              <CardHeader className="pb-3" data-id="element-264">
                <CardTitle className="text-sm font-medium flex items-center gap-2" data-id="element-265">
                  <Flame className="h-5 w-5 text-[#eb6641]" data-id="element-266" />
                  Aktueller Streak
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-267">
                <p className="text-4xl font-bold text-foreground" data-id="element-268">
                  {currentStreak}
                </p>
                <p className="text-sm text-muted-foreground mt-1" data-id="element-269">
                  Tage in Folge
                </p>
              </CardContent>
            </Card>

            <Card data-id="element-270">
              <CardHeader className="pb-3" data-id="element-271">
                <CardTitle className="text-sm font-medium flex items-center gap-2" data-id="element-272">
                  <TrendingUp className="h-5 w-5 text-[#eb6641]" data-id="element-273" />
                  Längster Streak
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-274">
                <p className="text-4xl font-bold text-foreground" data-id="element-275">
                  {longestStreak}
                </p>
                <p className="text-sm text-muted-foreground mt-1" data-id="element-276">
                  Tage insgesamt
                </p>
              </CardContent>
            </Card>

            <Card data-id="element-277">
              <CardHeader className="pb-3" data-id="element-278">
                <CardTitle className="text-sm font-medium flex items-center gap-2" data-id="element-279">
                  <BarChart3 className="h-5 w-5 text-[#eb6641]" data-id="element-280" />
                  Durchschnitt
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-281">
                <p className="text-4xl font-bold text-foreground" data-id="element-282">
                  {monthlyStats.averageCompletion}%
                </p>
                <p className="text-sm text-muted-foreground mt-1" data-id="element-283">
                  Completion Rate
                </p>
              </CardContent>
            </Card>
          </div>

          <Card data-id="element-284">
            <CardHeader data-id="element-285">
              <div className="flex items-center justify-between" data-id="element-286">
                <CardTitle data-id="element-287">Auswertung</CardTitle>
                <div className="flex gap-2" data-id="element-288">
                  <Button variant={statsView === 'week' ? 'default' : 'outline'} size="sm" onClick={() => setStatsView('week')} data-id="element-289">
                    Woche
                  </Button>
                  <Button variant={statsView === 'month' ? 'default' : 'outline'} size="sm" onClick={() => setStatsView('month')} data-id="element-290">
                    Monat
                  </Button>
                  <Button variant={statsView === 'year' ? 'default' : 'outline'} size="sm" onClick={() => setStatsView('year')} data-id="element-291">
                    Jahr
                  </Button>
                </div>
              </div>
            </CardHeader>
            <CardContent data-id="element-292">
              {statsView === 'week' && <div className="space-y-3" data-id="element-293">
                  {weeklyStats.map(day => <div key={day.date} className="flex items-center gap-4 p-4 border border-border rounded-lg hover:bg-[#fef5ee] transition-colors" data-id="element-294">
                      <div className="flex items-center gap-2 min-w-[120px]" data-id="element-295">
                        <Calendar className="h-4 w-4 text-muted-foreground" data-id="element-296" />
                        <span className="text-sm font-medium" data-id="element-297">{day.date}</span>
                      </div>
                      <div className="flex-1" data-id="element-298">
                        <div className="w-full bg-muted rounded-full h-2" data-id="element-299">
                          <div className="h-2 rounded-full bg-[#eb6641]" style={{
                    width: `${day.completionRate}%`
                  }} data-id="element-300" />
                        </div>
                      </div>
                      <div className="min-w-[80px] text-right" data-id="element-301">
                        <span className="text-sm font-medium" data-id="element-302">
                          {day.completed}/{day.total}
                        </span>
                        <span className="text-xs text-muted-foreground ml-2" data-id="element-303">
                          ({day.completionRate}%)
                        </span>
                      </div>
                    </div>)}
                </div>}

              {statsView === 'month' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-304">
                  <div className="space-y-4" data-id="element-305">
                    <div className="p-4 border border-border rounded-lg bg-[#fef5ee]" data-id="element-306">
                      <p className="text-sm text-muted-foreground" data-id="element-307">
                        Gesamt erledigt
                      </p>
                      <p className="text-2xl font-bold text-foreground mt-1" data-id="element-308">
                        {monthlyStats.completedTasks}/{monthlyStats.totalTasks}
                      </p>
                    </div>
                    <div className="p-4 border border-border rounded-lg" data-id="element-309">
                      <p className="text-sm text-muted-foreground" data-id="element-310">
                        Durchschnitt
                      </p>
                      <p className="text-2xl font-bold text-foreground mt-1" data-id="element-311">
                        {monthlyStats.averageCompletion}%
                      </p>
                    </div>
                  </div>
                  <div className="space-y-4" data-id="element-312">
                    <div className="p-4 border border-border rounded-lg" data-id="element-313">
                      <p className="text-sm text-muted-foreground" data-id="element-314">
                        Bester Tag
                      </p>
                      <p className="text-2xl font-bold text-[#eb6641] mt-1" data-id="element-315">
                        {monthlyStats.bestDay}
                      </p>
                    </div>
                    <div className="p-4 border border-border rounded-lg" data-id="element-316">
                      <p className="text-sm text-muted-foreground" data-id="element-317">
                        Verbesserungspotenzial
                      </p>
                      <p className="text-2xl font-bold text-foreground mt-1" data-id="element-318">
                        {monthlyStats.worstDay}
                      </p>
                    </div>
                  </div>
                </div>}

              {statsView === 'year' && <div className="text-center py-12" data-id="element-319">
                  <BarChart3 className="h-16 w-16 text-muted-foreground mx-auto mb-4" data-id="element-320" />
                  <p className="text-muted-foreground" data-id="element-321">
                    Jahresübersicht wird geladen...
                  </p>
                  <p className="text-sm text-muted-foreground mt-2" data-id="element-322">
                    Sammeln Sie mehr Daten für detaillierte Jahresstatistiken
                  </p>
                </div>}
            </CardContent>
          </Card>
        </>}

      {view === 'routine' && <>
          <div className="flex items-center justify-between p-4 bg-[#fef5ee] border border-[#eb6641]/20 rounded-lg" data-id="element-323">
            <div className="flex items-center gap-4" data-id="element-324">
              <div className="text-center" data-id="element-325">
                <p className="text-3xl font-bold text-foreground" data-id="element-326">
                  {getTotalCompleted()}/{tasks.length}
                </p>
                <p className="text-xs text-muted-foreground" data-id="element-327">Aufgaben</p>
              </div>
              <div className="h-12 w-px bg-border" data-id="element-328"></div>
              <div className="text-center" data-id="element-329">
                <p className="text-3xl font-bold text-[#eb6641]" data-id="element-330">
                  {getTotalCompletionRate()}%
                </p>
                <p className="text-xs text-muted-foreground" data-id="element-331">Fortschritt</p>
              </div>
            </div>
            <div className="flex gap-2" data-id="element-332">
              <Button variant="outline" onClick={resetAll} data-id="element-333">
                Zurücksetzen
              </Button>
              <Button variant="secondary" onClick={saveDay} data-id="element-334">
                Tag speichern
              </Button>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-335">
            {categories.map(category => {
          const categoryTasks = getTasksByCategory(category.key);
          const completed = getCompletedCount(category.key);
          const total = categoryTasks.length;
          const duration = getTotalDuration(category.key);
          return <Card key={category.key} data-id="element-336">
                  <CardHeader data-id="element-337">
                    <div className="flex items-start justify-between" data-id="element-338">
                      <div className="flex-1" data-id="element-339">
                        <CardTitle data-id="element-340">{category.title}</CardTitle>
                        <CardDescription data-id="element-341">
                          {category.description}
                        </CardDescription>
                      </div>
                      <div className="text-right" data-id="element-342">
                        <div className="text-sm font-medium text-foreground" data-id="element-343">
                          {completed}/{total}
                        </div>
                        <div className="flex items-center gap-1 text-xs text-muted-foreground mt-1" data-id="element-344">
                          <Clock className="h-3 w-3" data-id="element-345" />~{duration}min
                        </div>
                      </div>
                    </div>
                    <div className="w-full bg-muted rounded-full h-2 mt-3" data-id="element-346">
                      <div className="h-2 rounded-full bg-[#eb6641]" style={{
                  width: `${completed / total * 100}%`
                }} data-id="element-347" />
                    </div>
                  </CardHeader>
                  <CardContent className="space-y-2" data-id="element-348">
                    {categoryTasks.map(task => <div key={task.id} onClick={() => toggleTask(task.id)} className={`p-3 rounded-lg border cursor-pointer transition-all ${task.completed ? 'border-[#eb6641]/50 bg-[#fef5ee]' : 'border-border hover:bg-muted/30'}`} data-id="element-349">
                        <div className="flex items-start gap-3" data-id="element-350">
                          <div className="mt-0.5" data-id="element-351">
                            {task.completed ? <CheckCircle className="h-5 w-5 text-[#eb6641]" data-id="element-352" /> : <Circle className="h-5 w-5 text-muted-foreground" data-id="element-353" />}
                          </div>
                          <div className="flex-1" data-id="element-354">
                            <p className={`font-medium text-sm ${task.completed ? 'line-through text-muted-foreground' : 'text-foreground'}`} data-id="element-355">
                              {task.title}
                            </p>
                            <p className="text-xs text-muted-foreground mt-1" data-id="element-356">
                              {task.description}
                            </p>
                            <p className="text-xs text-[#eb6641] mt-1" data-id="element-357">
                              {task.duration}
                            </p>
                          </div>
                        </div>
                      </div>)}
                  </CardContent>
                </Card>;
        })}
          </div>
        </>}

      <div className="p-4 rounded-lg bg-[#fef5ee] border border-[#eb6641]/20" data-id="element-358">
        <p className="text-sm text-muted-foreground" data-id="element-359">
          <strong data-id="element-360">Tipp:</strong> Speichern Sie Ihren Fortschritt täglich, um
          langfristige Statistiken und Trends zu verfolgen. Ihr Streak motiviert
          Sie dranzubleiben!
        </p>
      </div>
    </div>;
}